module.exports = __webpack_public_path__ + "static/media/sliderTwo.9f5dc8a9.jpg";